<template lang="pug">
v-card.ma-2
  v-row(dense)
    v-col(cols='12' sm='3')
      v-dialog(
        v-model='isModalCrearUsuario',
        :max-width="isMovil ? '100%' : '500px'"
        transition='dialog-bottom-transition'
        :fullscreen="isMovil"
      )
        v-card.pa-6
          h1.h1-nuevo Nuevo usuario
          v-layout(align-center justify-center)
            v-flex(class='login-form' class='text-xs-center')
              v-form
                v-text-field(
                  v-model='nuevoUsuario.nombre'
                  light
                  prepend-icon='person'
                  label='Nombre completo / Razon social'
                  @keyup="(e) => { nuevoUsuario.nombre =  e.target.value.toUpperCase() }"
                  ref="nombre"
                  type='text',
                    @keyup.enter="fetchRegistrar()"
                )
                v-text-field(
                  v-model='nuevoUsuario.username'
                  @keyup="(e) => { nuevoUsuario.username =  e.target.value.toLowerCase() }"
                  light
                  prepend-icon='email'
                  label='Email (Requerido)'
                  ref="username"
                  type='email',
                  @keyup.enter="fetchRegistrar()"
                )
                v-text-field(
                  v-model='nuevoUsuario.password'
                  prepend-icon='lock'
                  :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                  ref="password"
                  :type="showPassword ? 'text' : 'password'"
                  label='Ingrese una contraseña',
                  @click:append='showPassword = !showPassword'
                  loading,
                  hint="La contraseña que usted ingrese sera encriptada para mayor seguridad",
                  persistent-hint,
                  @keyup.enter="fetchRegistrar()"
                )
                  template(v-slot:progress='')
                    v-progress-linear( :value='progress' :color='color' absolute='' height='2')
                v-text-field(
                  prepend-icon='lock'
                  :append-icon="showPassword1 ? 'visibility' : 'visibility_off'"
                  ref="password1"
                  :type="showPassword1 ? 'text' : 'password'"
                  label='Repita la contraseña'
                  v-model='nuevoUsuario.password1'
                  @click:append='showPassword1 = !showPassword1',
                  @keyup.enter="fetchRegistrar()"
                )
                v-checkbox.mt-0.pt-0(v-model='nuevoUsuario.aceptaPoliticasDePrivacidad' color='primary', label="Protección de datos personales (LEY Nº 29733)")
                  template(v-slot:label='')
                    div(@click.stop="")
                      | ¿Aceptas compartir tus datos personales? &nbsp;
                      a(href='#'  @click.prevent="redirectProteccion()" ) LEY Nº 29733
                v-btn( block color="success", @click="fetchRegistrar()", small ) Registrar
      .d-flex.pa-4.pb-1
        v-text-field(
          v-model='search'
          @keyup.enter="fetch()",
          @click:clear="fetch(true)"
          dense
          label='Busca por email, nombre'
          hide-details=''
          clearable=''
          clear-icon='close'
          solo
        )
        v-card.d-flex.elevation-0.ai-center
          v-btn.mx-1( fab color="primary" @click="fetch(), fetchCountUsuarios()")
            v-icon sync
          v-btn.mx-1( fab color="success" @click="openDialogCrearUsuario" v-if="perfilUsuario === 'sistemas'" )
            v-icon add
          v-menu(bottom='' origin='center center' transition='scale-transition' :close-on-content-click="false"
            location="end")
            template(v-slot:activator='{ on, attrs }')
              v-badge(
                :value="countFilters ? 1 : 0"
                :content="countFilters ? countFilters : 0"
                overlap
              )
                v-btn.mx-1( fab    v-bind='attrs' v-on='on' )
                  v-icon filter_list
            v-card.pa-4
              .d-flex.ai-center.mb-2
                v-checkbox.ma-0(v-model='isCuentasPendientesEmail' name="isCuentasPendienteEmail"  id="isCuentasPendienteEmail" color='primary'  hide-details @change="fetch()" )
                label.font-size-12(:class="{'!primary--text font-weight-700' : isCuentasPendientesEmail}" for="isCuentasPendienteEmail") Pendientes de verificar email
              .d-flex.ai-center.mb-2
                v-checkbox.ma-0(v-model='isCuentasPendientes' name="isCuentasPendientes"  id="isCuentasPendientes" color='primary'  hide-details @change="fetch()" )
                label.font-size-12(:class="{'!primary--text font-weight-700' : isCuentasPendientes}" for="isCuentasPendientes") Pendientes de aprobación de cuenta
      v-card.mx-auto.overflow-y-auto.elevation-0(
        height="calc(100vh - 127px)" v-infinite-scroll='fetchByScroll',
        infinite-scroll-disabled='disabledScrollExcecute',
        infinite-scroll-distance='2'
      )
        v-list.py-0(dense )
          v-list-item.py-0(dense v-for='(item, index) in lista'  :key='index' @click="renderEditar(item)" :color="selected && (selected.usuario === item.usuario) ? 'bg-secondary primary--text' : ''")
            v-list-item-avatar.my-1.me-2
              v-avatar(color='secondary', size="34")
                avatar-perfil(:path="item.foto")
            v-list-item-content.pa-0
              v-list-item-title( :class="{'primary--text' : (selected && selected.usuario === item.usuario) }")
                .d-flex.fd-column
                  small.font-size-11.font-weight-700 {{item.nombre}}
                  .d-flex
                    small.font-size-11.text-muted {{item.usuario}}
                    small.font-size-11.ml-1(:class="{'blue--text' : item.perfil === 'usuario-contrato',  'primary--text' : item.perfil === 'usuario'}") ({{item.perfil}})
            v-list-item-action(v-if="item.perfil !== 'usuario-contrato'")
                v-fade-transition(leave-absolute='')
                  v-tooltip(top='')
                    template(v-slot:activator='{ on, attrs }')
                      v-icon(center='', size="20"  v-bind='attrs' v-on='on' :color="item.emailConfirmado ? 'success' : 'background'" )
                        | {{item.emailConfirmado ? 'check_circle' : 'timer' }}
                    small {{item.emailConfirmado ? 'Verificado' : 'No verificado'}}
            v-list-item-action(v-else)
                v-fade-transition (leave-absolute='')
                  v-tooltip(top='')
                    template(v-slot:activator='{ on, attrs }')
                      v-icon(center='', size="20"  v-bind='attrs' v-on='on' :color="item.emailConfirmado && item.fechaCuentaActivada ? 'success' : 'background'" )
                        | {{item.emailConfirmado && item.fechaCuentaActivada ? 'check_circle' : 'timer' }}
                    small {{item.emailConfirmado && item.fechaCuentaActivada ? 'Verificado' : 'No verificado'}}

    v-col(cols='12' sm='9')
      v-dialog(
        v-model='isAccountsList'
        width="680",
        @click:outside="closeModalIsAccountsList()",
        transition='dialog-bottom-transition'
      )
        v-card.pa-4
          .d-flex.mx-4
            h1.text-left.font-weight-700.font-size-15.py-2.mb-4 Listado de cuentas relacionadas
            v-spacer
          v-card-text
            span(v-if="isLoadingGetAccounts") cargando...
            .d-flex.fd-column(v-if="selected && !isLoadingGetAccounts")
              usuario-seleccionar(
                :perfiles="[selected.perfil]"
                multiple
                :username="usuariosRelacionados"
                :no-solo="false"
                @user-selected="obtenerUsuarioSeleccionado",
                ref="lista_usuarios_manager"
              )
          v-card-actions
            v-spacer
            v-btn(color='ligth' v-if="!isMovil"   @click='closeModalIsAccountsList()')
              small Cancelar
            v-btn(color='success' :loading="isLoadingActivating" :block ="isMovil" @click='fetchGuardarCuentas()')
              small Guardar cambios
      v-dialog(
        v-model='isActiveAccountEmail'
        width="500",
        @click:outside="closeModalIsActiveAccountEmail()",
        transition='dialog-bottom-transition'
      )
        v-card.pa-4
          h1.text-center.font-weight-700.font-size-25.py-2 Verificar email
          v-card-text
            span Presiona confirmar si deseas verificar el email para la siguiente cuenta de Help Desk.
            strong.ml-3.primary--text {{selected ? selected.razonSocial : null}}
          v-card-actions
            v-spacer
            v-btn(color='ligth' v-if="!isMovil" text=''  @click='closeModalIsActiveAccountEmail()')
              small Cancelar
            v-btn(color='success' :loading="isLoadingActivatingEmail" :block ="isMovil" @click='fetchActivateAccountEmail()')
              small Confirmar
      v-dialog(
        v-model='isActiveAccount'
        width="500",
        @click:outside="closeModalIsActiveAccount()",
        transition='dialog-bottom-transition'
      )
        v-card.pa-4
          h1.text-center.font-weight-700.font-size-25.py-2 Activar cuenta
          v-card-text
            span Verifica los datos y presiona confirmar si deseas activar la siguiente cuenta de Help Desk.
            strong.ml-3.primary--text {{selected ? selected.razonSocial : null}}
          v-card-actions
            v-spacer
            v-btn(color='ligth' v-if="!isMovil" text=''  @click='closeModalIsActiveAccount()')
              small Cancelar
            v-btn(color='success' :loading="isLoadingActivating" :block ="isMovil" @click='fetchActivateAccount()')
              small Confirmar
      v-dialog(
        v-model='isActiveManagerAccount'
        width="500",
        @click:outside="closeModalIsActiveManagerAccount()",
        transition='dialog-bottom-transition'
      )
        v-card.pa-4
          h1.text-center.font-weight-700.font-size-25.py-2 {{ isManagerAccount ? 'Activar permisos de administrador' : 'Desactivar permisos de administrador' }}
          v-card-text
            span Al activar esta opcion la cuenta podra tener visibilidad de los usuarios que tengan relacion con
            strong.ml-3.primary--text {{selected ? selected.razonSocial : null}}
          v-card-actions
            v-spacer
            v-btn(color='ligth' v-if="!isMovil" text=''  @click='closeModalIsActiveManagerAccount()')
              small Cancelar
            v-btn(color='success' :loading="isLoadingActivating" :block="isMovil" @click='fetchActivateManagerAccount()')
              small Confirmar
      v-card.d-flex.fd-column.jc-center.ai-center.pa-6.elevation-0(v-if="!selected", height="calc(100vh - 68px)")
        v-icon(color="background", size="100") person_search
        span.font-weight-700.primary--text
          | No se selecciono un usuario
        span.text-muted.font-size-12 Seleccione un usuario en el panel isquierdo
      .d-flex.fd-column(v-if="selected", color="white", :class="{'border-radius-none' : isMovil}")
        v-list(two-line='' v-if="perfilUsuario !== 'sistemas'" )
          v-list-item
            .position-relative
              v-avatar.elevation-1(:size="50")
                avatar-perfil(:path="selected.foto" gradient)
            v-list-item-content.ml-3
              v-list-item-title
                .d-flex
                  span.font-weight-700.mr-2.font-size-17 {{ selected.nombre }}
                  v-chip.font-weight-700.elevation-1(color="success" v-if="(selected.fechaCuentaActivada && selected.perfil === 'usuario-contrato') || (selected.emailConfirmado && selected.perfil === 'usuario')")
                    v-icon.mr-1(size="15") check
                    span Activo
                  v-chip.font-weight-700.elevation-1(color="warning" v-else)
                    v-icon.mr-1(size="15") timer
                    span Pendiente
              v-list-item-subtitle( :class="isMovil ? 'font-size-12' : 'font-size-12'")
                span {{selected.cargo}}
                span(v-if="perfilUsuario !== 'usuario-contrato'") &nbsp; ({{selected.tipoArea}}/{{selected.zonaGarantia}})
            v-list-item-action
              v-menu(transition='slide-x-transition' bottom='' right='')
                template(v-slot:activator='{ on, attrs }')
                  v-btn.animated.fadeInUp.faster(icon   v-bind='attrs' v-on='on' :disabled="perfilUsuario === 'supervisor'")
                    v-icon  more_vert
                v-list(dense)
                  v-list-item(@click="enviarDatosDelUsuario()")
                    v-list-item-title
                      | Enviar datos del usuario al SIV
          v-alert.elevation-2.py-3.ma-1.animated.fadeInRight.faster(dense border="left" type='warning' v-if="(perfilUsuario === 'dispatcher' || perfilUsuario === 'supervisor' || perfilUsuario === 'sistemas') && selected && selected.tokenVerifyEmail ")
            .d-flex
              small.font-size-12.font-weight-700 Esta cuenta esta pendiente de verificar email.
              v-spacer
              v-btn(  small color="white warning--text", @click="openModalIsActiveAccountEmail()"  )
                v-icon check
                small.is-bold Verificar email
          v-alert.elevation-2.py-3.ma-1.animated.fadeInRight.faster(dense border="left" type='warning' v-if="(perfilUsuario === 'dispatcher' || perfilUsuario === 'supervisor' || perfilUsuario === 'sistemas') && selected && selected.perfil === 'usuario-contrato' && selected.emailConfirmado && !selected.fechaCuentaActivada ")
            .d-flex
              small.font-size-12.font-weight-700 Esta cuenta esta pendiente de activación.
              v-spacer
              v-btn( small  color="white warning--text", @click="openModalIsActiveAccount()"  )
                v-icon check
                small.is-bold Activar cuenta
        v-list.px-4.py-0(v-if="selected && selected.fechaCuentaActivada")
          v-list-item
            v-list-item-icon
              v-icon(color='primary' :size="23")
                | person
            v-list-item-content
              v-list-item-title
                span.font-size-13.font-weight-700 Otorgar permisos para manejar otras cuentas
              v-list-item-subtitle
                span.font-size-12 Visibilidad de todas las acciones de cuentas relacionados.
            v-list-item-action
              .d-flex.ai-center.jc-center
                v-btn.mr-2(color='info' :loading="isLoadingActivating" small :block="isMovil" @click='openModalIsAccountsList()' v-if="selected.esCuentaAdministrador")
                  small Administrar cuentas
                v-switch(dense @change="openModalIsActiveManagerAccount()" v-model="isManagerAccount")
        item-usuario(
          v-if="isRenderComponent && selected.usuario &&  perfilUsuario !== 'sistemas'"
          :datos="selected"
          show-details
        )
        form-editar-usuario( v-else-if="isRenderComponent && selected.usuario && perfilUsuario === 'sistemas'" :username="selected.usuario", :validar="perfilUsuario !== 'sistemas'")

</template>
<script>
  import avatarPerfil from '@/components/c_avatar_perfil'
  import usuarioEditar from '@/components/c_usuario_form_editar_datos'
  import itemUsuario                 from '@/components/c_card_informacion_usuario'
  import usuariosSeleccionar         from '@/components/c_usuarios_lista_seleccionar'
  import moment                 from 'moment'
  import  { apiGet, notify, apiPost } from '../util/general'
  export default {
    components : {
      'avatar-perfil'      : avatarPerfil,
      'form-editar-usuario': usuarioEditar,
      'item-usuario'       : itemUsuario,
      'usuario-seleccionar'          : usuariosSeleccionar
    },
    data () {
      return {
        lista              : [],
        search             : '',
        selected           : null,
        isActiveManagerAccount  : false,
        isAccountsList  : false,
        listaCuentas  : [],
        isRenderComponent  : false,
        isModalCrearUsuario: false,
        isLoadingSaveAccounts: false,
        isLoadingGetAccounts: false,
        isLoadingActivating: false,
        isManagerAccount: false,
        showPassword       : false,
        showPassword1      : false,
        nuevoUsuario       : {
          nombre                     : '',
          username                   : '',
          password                   : '',
          password1                  : '',
          aceptaPoliticasDePrivacidad: true
        },
        id                    : 0,
        usuariosRelacionados                  : '',
        isScroll              : true,
        disabledScrollExcecute: true,
        noMore                : false,
        isLoadingActivatingManager : false,
        totalUsuarios : 0,
        perfilUsuario : localStorage.getItem('perfil') || '',
        usuarioLogged : localStorage.getItem('username') || '',
        isCuentasPendientes: false,
        isCuentasPendientesEmail: false,
        isLoadingActivatingEmail: false,
        isActiveAccount: false,
        isActiveAccountEmail: false,
        sivWebCliente     : process.env.SIV_WEB_ROUTE
      }
    },
    created () {
      var vm = this
      vm.fetch()
      if (vm.perfilUsuario === 'sistemas')  vm.fetchCountUsuarios()
    },
    computed : {
      isMovil () {
        var vm = this
        return vm.$vuetify.breakpoint.smAndDown
      },
      progress () {
        var vm = this
        return Math.min(100, vm.nuevoUsuario.password.length * 16.7)
      },
      color () {
        var vm = this
        return ['error', 'warning', 'success'][Math.floor(vm.progress / 40)]
      },
      countFilters () {
        var vm = this
        var count = 0
        if (vm.isCuentasPendientes) count++
        if (vm.isCuentasPendientesEmail) count++
        return count
      }
    },
    filters : {
      fecha: function (value) {
        return moment(value).format('DD/MM/YYYY HH:mm')
      }
    },
    methods : {
      enviarDatosDelUsuario () {
        var vm = this
        var query = ``
        Object.keys(vm.selected).forEach(e => {
          if (e !== 'foto' && e !== 'password' && e !== 'emailConfirmado' && e !== 'rutaSctr' && e !== 'resetToken' && e !== 'tokenVerifyEmail' && e !== 'direccion') {
            query += `${e}=${vm.selected[e]}&`
          }
        })
        var ruta = `${vm.sivWebCliente}/#/cliente-administrador?${query}`
        window.open(ruta, '_blank')
      },
      fetchActivateManagerAccount () {
        var vm = this
        vm.isLoadingActivatingManager = true
        var url = ''
        if (!vm.isManagerAccount) url = '/usuario/desactivar/manager'
        else url = '/usuario/activar/manager'
        var obj = {
          email: vm.selected.usuario
        }
        vm.$store.dispatch('transaccion', { isProceso : true, message : 'Activando cuenta' })
        apiPost(vm, url, obj, function (data) {
          vm.closeModalIsActiveManagerAccount()
          notify(vm, 'success', 'Exito', 'Los cambios se efectuaron correctamente')
          vm.fetch()
        }, function (error) {
          notify(vm, 'error', 'Error', error.message)
        }, function () {
          vm.$store.dispatch('transaccion', {isProceso : false})
          vm.isLoadingActivatingManager = false
        })
      },
      fetchActivateAccount () {
        var vm = this
        vm.isLoadingActivating = true
        var obj = {
          email: vm.selected.usuario
        }
        vm.$store.dispatch('transaccion', { isProceso : true, message : 'Activar cuenta' })
        apiPost(vm, '/usuario/activar/cuenta', obj, function (data) {
          vm.closeModalIsActiveAccount()
          notify(vm, 'success', 'Exito', 'La cuenta fue activada correctamente')
          vm.fetch()
        }, function (error) {
          notify(vm, 'error', 'Error', error.message)
        }, function () {
          vm.$store.dispatch('transaccion', {isProceso : false})
          vm.isLoadingActivating = false
        })
      },
      fetchActivateAccountEmail () {
        var vm = this
        vm.isLoadingActivatingEmail = true
        console.log('vm.selected', vm.selected)
        var obj = {
          email: vm.selected.usuario,
          tokenVerify: vm.selected.tokenVerifyEmail
        }
        vm.$store.dispatch('transaccion', { isProceso : true, message : 'Validar cuenta' })
        apiPost(vm, '/usuario/verificar/email', obj, function (data) {
          vm.closeModalIsActiveAccountEmail()
          notify(vm, 'success', 'Exito', 'El email fué validado correctamente')
          vm.fetch()
        }, function (error) {
          notify(vm, 'error', 'Error', error.message)
        }, function () {
          vm.$store.dispatch('transaccion', {isProceso : false})
          vm.isLoadingActivatingEmail = false
        })
      },
      fetchGuardarCuentas () {
        var vm = this
        vm.isLoadingSaveAccounts = true
        var seleccionados = vm.$refs.lista_usuarios_manager.seleccionado || []
        console.log('seleccionados', seleccionados)
        var cuentas = seleccionados.map(e => { return { usuario : e.usuario, razonSocial: e.razonSocial, ruc : e.ruc } })
        var obj = {
          email: vm.selected.usuario,
          cuentas: cuentas
        }
        vm.$store.dispatch('transaccion', { isProceso : true, message : 'Desactivar cuenta' })
        apiPost(vm, '/usuario/guardar/cuentas', obj, function (data) {
          vm.closeModalIsAccountsList()
          notify(vm, 'success', 'Exito', 'La cuenta fue activada correctamente')
          // vm.fetch()
        }, function (error) {
          notify(vm, 'error', 'Error', error.message)
        }, function () {
          vm.$store.dispatch('transaccion', {isProceso : false})
          vm.isLoadingSaveAccounts = false
        })
      },
      openModalIsActiveAccount () {
        var vm = this
        vm.isActiveAccount = true
      },
      closeModalIsActiveAccount () {
        var vm = this
        vm.isActiveAccount = false
      },
      openModalIsActiveAccountEmail () {
        var vm = this
        vm.isActiveAccountEmail = true
      },
      closeModalIsActiveAccountEmail () {
        var vm = this
        vm.isActiveAccountEmail = false
      },
      openModalIsAccountsList () {
        var vm = this
        vm.isAccountsList = true
        vm.fetchGetAccountsList()
      },
      closeModalIsAccountsList () {
        var vm = this
        vm.isAccountsList = false
      },
      openModalIsActiveManagerAccount () {
        var vm = this
        vm.isActiveManagerAccount = true
      },
      closeModalIsActiveManagerAccount () {
        var vm = this
        vm.isActiveManagerAccount = false
        vm.isManagerAccount = vm.selected.esCuentaAdministrador === 1
      },
      obtenerUsuarioSeleccionado (usuario) {
        var vm = this
        vm.usuarioSeleccionado = usuario.usuario
      },
      fetchByScroll () {
        var vm = this
        vm.isScroll = true
        vm.fetch()
      },
      limpiarObjCreacion  () {
        var vm = this
        vm.nuevoUsuario.nombre                      = ''
        vm.nuevoUsuario.username                    = ''
        vm.nuevoUsuario.password                    = ''
        vm.nuevoUsuario.password1                   = ''
        vm.nuevoUsuario.aceptaPoliticasDePrivacidad = true
      },
      validateEmail (email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
      },
      fetchRegistrar () {
        var vm          = this
        var url = '/usuario/registrar'
        if (!vm.nuevoUsuario.nombre) {
          notify(vm, 'error', 'Error', 'Ingrese un nombre u razon social valido')
          vm.$refs.nombre.focus()
          return
        }

        if (!vm.nuevoUsuario.username) {
          notify(vm, 'error', 'Error', 'Ingrese un email valido')
          vm.$refs.username.focus()
          return
        }

        if (vm.nuevoUsuario.username) {
          if (!vm.validateEmail(vm.nuevoUsuario.username)) {
            notify(vm, 'error', 'Error', 'El email no cumple con el formato adecuado')
            vm.$refs.username.focus()
            return
          }
        }

        if (!vm.nuevoUsuario.password) {
          notify(vm, 'error', 'Error', 'Ingrese un password valido')
          vm.$refs.password.focus()
          return
        }

        if (vm.nuevoUsuario.password && vm.progress < 100) {
          notify(vm, 'error', 'Error', 'La contraseña debe de tener como minimo 6 caracteres')
          vm.$refs.password.focus()
          return
        }

        if (!vm.nuevoUsuario.password1) {
          notify(vm, 'error', 'Error', 'Repita la contraeña ingresada')
          vm.$refs.password1.focus()
          return
        }

        if (vm.nuevoUsuario.password !== vm.nuevoUsuario.password1) {
          notify(vm, 'error', 'Error', 'Las contraseñas ingresadas no coinciden')
          vm.nuevoUsuario.password1 = ''
          vm.$refs.password1.focus()
          return
        }

        var obj = {
          nombre                     : vm.nuevoUsuario.nombre,
          username                   : vm.nuevoUsuario.username,
          password                   : vm.nuevoUsuario.password,
          // isUsuarioInterno           : true,
          aceptaPoliticasDePrivacidad: vm.nuevoUsuario.aceptaPoliticasDePrivacidad ? 1 : 0
        }

        apiPost(vm, url, obj, data => {
          notify(vm, 'success', 'Exito', 'El usuario se registro correctamente')
          vm.fetch()
          vm.renderEditar(vm.nuevoUsuario)
          vm.closeDialogCrearUsuario()
        }, error => {
          notify(vm, 'error', 'Error', error.message)
        })
      },
      openDialogCrearUsuario () {
        var vm = this
        vm.isModalCrearUsuario = true
      },
      closeDialogCrearUsuario () {
        var vm = this
        vm.limpiarObjCreacion()
        vm.isModalCrearUsuario = false
      },
      fetchGetAccountsList () {
        var vm = this
        vm.isLoadingGetAccounts = true
        vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obtener listado de cuentas' })
        var obj = {
          email    : vm.selected.usuario
        }
        apiGet(vm, '/usuario/obtener/cuentas/relacionados', obj, function (data) {
          var users = data.lista.map(e => e.usuario)
          vm.usuariosRelacionados = users.toString()
        }, function (error) {
          notify(vm, 'error', 'Error', error.message)
        }, function () {
          vm.isLoadingGetAccounts = false
          vm.$store.dispatch('transaccion', { isProceso : false })
        })
      },
      fetch (isClear = false) {
        var vm = this
        if (isClear) {
          vm.search = ''
        }
        if (!vm.isScroll) {
          vm.lista = []
          vm.id = 0
          vm.selected = null
          vm.isRenderComponent = false
        }

        vm.disabledScrollExcecute = true
        vm.noMore                 = false
        vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obtener listado de usuarios' })

        var obj = {
          id    : vm.id,
          razonSocial: vm.search,
          isIncludeAdmin: vm.perfilUsuario === 'sistemas' ? 1 : 0,
          isCuentasPendientes: vm.isCuentasPendientes ? 1 : 0,
          isCuentasPendientesEmail: vm.isCuentasPendientesEmail ? 1 : 0
        }
        apiGet(vm, '/usuario/obtener/listado', obj, function (data) {
          for (var i = 0; i < data.lista.length; i++) {
            vm.lista.push(data.lista[i])
          }
          if (data.noMore) {
            vm.noMore = true
            vm.disabledScrollExcecute = true
          } else {
            vm.id = data.id
            vm.disabledScrollExcecute = false
          }
        }, function (error) {
          vm.disabledScrollExcecute = true
          notify(vm, 'error', 'Error', error.message)
        }, function () {
          vm.isScroll  = false
          vm.$store.dispatch('transaccion', { isProceso : false })
        })
      },
      fetchCountUsuarios () {
        var vm = this
        var obj = {}
        apiGet(vm, '/usuario/count', obj, function (data) {
          console.log('data', data)
          vm.totalUsuarios = data.lista[0].cantidad
        }, function (error) {
          notify(vm, 'error', 'Error', error.message)
        })
      },
      renderEditar (item) {
        var vm = this
        console.log('item', item)
        vm.selected = item
        vm.isManagerAccount = item.esCuentaAdministrador === 1
        vm.isRenderComponent = false
        vm.$nextTick(() => {
          vm.isRenderComponent = true
        })
      }
    }
  }
</script>
<style lang="stylus" scoped>
.h1-nuevo
  font-size: 30px !important
  font-weight: 700 !important
</style>




// WEBPACK FOOTER //
// View_administrador_usuarios.vue?7d4c7fa4